export interface ZoomLimits {
	min: number;
	max: number;
	step: number;
}

export const CANVAS_ZOOM_DEFAULT = 100;

export const DEFAULT_ZOOM_LIMITS: ZoomLimits = {
	min: 20,
	max: 300,
	step: 20
};

export const PLANOGRAM_ZOOM_LIMITS: ZoomLimits = {
	min: 60,
	max: 500,
	step: 20
};

export const EQUIPMENT_ZOOM_LIMITS: ZoomLimits = {
	min: 20,
	max: 400,
	step: 20
};

export const PLAN_VIEW_ZOOM_LIMITS: ZoomLimits = {
	min: 60,
	max: 400,
	step: 20
};

export function clampZoom(value: number, limits: ZoomLimits): number {
	return Math.min(Math.max(value, limits.min), limits.max);
}
